
module.exports = function LiveInputWidget ($host, config) {

  // Setup
  var $input = $('[data-table-search-input]', $host);

  // Widgets
  var status = getWidgetAtDom($('[data-filter-value="status"]'), $host);
  var type   = getWidgetAtDom($('[data-filter-value="type"]'),   $host);

  // State
  var callbacks = { change: id };

  // Functions
  function focusWithKeystroke (key) {
    focus();
  }

  function focus () {
    $input.focus();
  }

  function clear () {
    $input.val('');
    dispatchCombinedValue();
  }

  function dispatchCombinedValue () {
    var query       = $input.val();
    var statusValue = status.getValue();
    var typeValue   = type.getValue();

    if (statusValue !== '*') query += ' ' + statusValue;
    if (typeValue   !== '*') query += ' ' + typeValue;
    callbacks.change(query);
  }

  // Listeners
  $input.on('keyup', dispatchCombinedValue);
  if (status) status.onSelection(dispatchCombinedValue);
  if (type)   type.onSelection(dispatchCombinedValue);

  // Interface
  return {
    clear: clear,
    focus: focus,
    focusWithKeystroke: focusWithKeystroke,
    onChange: function (λ) { callbacks.change = λ; }
  };

}

